import { IconEyeOff, IconEye } from "@tabler/icons-react";

/**
 * @typedef {object} InputWithHiddenIconProps
 * @property {string} label
 * @property {boolean} isHidden
 * @property {object} TextFieldProps
 * @property {object} IconButtonProps
 */

const InputWithHiddenIcon = props => {
  const { label, isHidden, TextFieldProps, IconButtonProps } = props;

  return (
    <div>
      <label className="form-label" style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
        {label}
      </label>

      <div className="d-flex align-items-center gap-2" style={{ maxWidth: 800 }}>
        <input
          type="text"
          className="form-control"
          style={{ borderRadius: 8, padding: "10px 14px" }}
          {...TextFieldProps}
        />

        <button
          type="button"
          className="btn btn-icon"
          style={{
            border: "1px solid #ccc",
            borderRadius: 8,
            backgroundColor: "#fff",
            width: 40,
            height: 40,
            minWidth: 40,
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
            opacity: IconButtonProps?.disabled ? 0.5 : 1,
          }}
          {...IconButtonProps}
        >
          {isHidden ? (
            <IconEye size={24} color="#666" />
          ) : (
            <IconEyeOff size={24} color="#666" />
          )}
        </button>
      </div>
    </div>
  );
};

export default InputWithHiddenIcon;
